module.exports = __webpack_public_path__ + "static/media/day-1-30.d31bba1e.jpg";